// Mutation hook - forward wiadomosci Notify (server-side dolacza zalaczniki parenta).
// POST /api/ui/sales-crm/mailbox/forward-notify/{notifyId}
// Sprint 3 v4.1.

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IPostForwardNotifyRequest,
  IPostForwardNotifyResponse
} from 'api/types/composer';

export interface IUsePostForwardNotifyParams {
  notifyId: number;
  dealId?: number;
  threadId?: number;
  body: IPostForwardNotifyRequest;
}

const postForwardNotify = (
  params: IUsePostForwardNotifyParams
): Promise<IPostForwardNotifyResponse> =>
  axios.post(`/sales-crm/mailbox/forward-notify/${params.notifyId}`, params.body);

export const usePostForwardNotify = (
  options?: UseMutationOptions<IPostForwardNotifyResponse, IError, IUsePostForwardNotifyParams>
) => {
  const queryClient = useQueryClient();
  return useMutation<IPostForwardNotifyResponse, IError, IUsePostForwardNotifyParams>(
    postForwardNotify,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        if (variables.dealId) {
          await queryClient.invalidateQueries(['sales-crm-notify', 'by-deal', variables.dealId]);
          await queryClient.invalidateQueries(['sales-crm-notify', 'threads', 'by-deal', variables.dealId]);
        }
        if (variables.threadId) {
          await queryClient.invalidateQueries(['sales-crm-notify', 'by-thread', variables.threadId]);
        }
        options?.onSuccess?.(data, variables, context);
      }
    }
  );
};
